import { defineComponent as _defineComponent } from 'vue'
import { faPlay } from '@fortawesome/free-solid-svg-icons';
import { useExperiment } from '@/libraries/experiment';


export default /*#__PURE__*/_defineComponent({
  __name: 'PromotionRowCTAMBRExp',
  props: {
    isHighlighted: { type: Boolean },
    hasPromotionTag: { type: Boolean }
  },
  setup(__props: any) {



const { activeVariantWithControlGroup: buyRentExpVariant } = useExperiment('EXP_MERGE_BUY_RENT');

return { __sfc: true,buyRentExpVariant, faPlay }
}

})